
// constants as defined in RevoXef’s App\Models\Config\Business
const NONE = 0
const SIMPLE = 1
const FULL = 2
const AUTO = 3

export default {
  NONE,
  SIMPLE,
  FULL,
  AUTO,

  isManual: (v) => {
    return [SIMPLE, FULL].indexOf(v) !== -1
  },
}
